import { SVGProps } from 'react';

const Shrimp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 12h.01M13 22c.5-.5 1.12-1 2.5-1m0 0c-1.38 0-2-.5-2.5-1m2.5 1a6.5 6.5 0 1 0 0-13H4.387a2.387 2.387 0 1 1 .216-4.763l6.17.561A3.28 3.28 0 0 0 14 2m1.5 19a2.5 2.5 0 0 0 0-5H12a7 7 0 0 1-7-7V8m9 0a8.5 8.5 0 0 1 0 8m2 0c2 0 4.5-4 4-6"
    />
  </svg>
);
export default Shrimp;
